import { TableStyled } from '@procurify/ui'
import styled from 'styled-components'

interface IExportPreviewStyledProps {}

export const ExportPreviewStyled = styled.div<IExportPreviewStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  position: relative;
  overflow-x: auto;

  border: 1px solid ${(props) => props.theme.colors.content.border};

  min-height: ${(props) => props.theme.typography.pxToRem(100)};

  ${/* sc-selector*/ TableStyled} th,
  ${/* sc-selector*/ TableStyled} td {
    white-space: nowrap;
    font-family: 'consolas', sans-serif;

    max-width: ${(props) => props.theme.typography.pxToRem(200)};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${/* sc-selector*/ TableStyled},
  ${/* sc-selector*/ TableStyled} tr,
  ${/* sc-selector*/ TableStyled} th,
  ${/* sc-selector*/ TableStyled} td {
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.content.border};
  }

  ${/* sc-selector*/ TableStyled} th + th,
  ${/* sc-selector*/ TableStyled} td + td {
    border-left: 1px solid ${(props) => props.theme.colors.content.border};
  }

  ${/* sc-selector*/ TableStyled} th:last-child,
  ${/* sc-selector*/ TableStyled} td:last-child {
    border-right: none;
  }

  .sample-data-overlay {
    position: sticky;

    /* stylelint-disable */
    bottom: 0;
    left: 1px;
    right: 1px;

    min-height: 100px;
    margin-top: -100px;
    padding-bottom: 1em;
    /* stylelint-enable */

    display: flex;
    align-items: flex-end;
    justify-content: center;
    text-align: center;

    overflow: hidden;

    > * {
      z-index: 1;
    }

    &:before {
      z-index: 0;
      content: '';
      display: block;
      position: absolute;

      bottom: 0;

      width: 100%;
      height: 1px; /* stylelint-disable-line */
      box-shadow: 0 0 30px 40px ${(props) => props.theme.colors.white};
    }
  }
`
